module.exports = "/assets/bf96339886eed2b351ade4c63d969eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hotel_default.png
// module id = 503
// module chunks = 0